import * as Yup from 'yup';
import {
  type ReorderWeeks,
  reorderWeeks,
  type ThresholdWeeks,
  thresholdWeeks,
} from './order-settings';
import { type SaleStatDays, saleStatDays } from './product';

// form validation rules
export const OrderOptionsSchema = Yup.object().shape({
  qoh_threshold_weeks: Yup.mixed<ThresholdWeeks>().oneOf(thresholdWeeks).defined().required(),
  reorder_weeks: Yup.mixed<ReorderWeeks>().oneOf(reorderWeeks).defined().required(),

  send_methods: Yup.array().of(Yup.string().required()).required(),
  emails: Yup.array().of(Yup.string().email().required()).required(),

  // qoh_threshold_percent is deliberately not declared. Nothing reads it, and
  // requiring it here is what would break the deploy window when the API stops
  // sending it (ORD-391): a browser on the old bundle would fail validation on
  // every order response. Yup keeps undeclared keys rather than stripping them,
  // so the value still round-trips and the API's `required` stays satisfied
  // until the field is removed server-side — see the round-trip test.
  //
  // sales_period_days IS still read by getSuggestedQuantities, so it stays.
  sales_period_days: Yup.mixed<SaleStatDays>().oneOf(saleStatDays).defined().required(),
});

export type OrderOptions = Yup.InferType<typeof OrderOptionsSchema>;
